shvenergy.responsivetables = (function ($) {
	"use strict";
    var cdnvalue = $("#cdnInput").data("value");
	function init() {

		var responsiveTables = $(".text-area").find("table");

		if (responsiveTables.length <= 0)
			return;

		let template = "";
		template += `<div class="show-overlay" aria-hidden="true">
					<svg width="64" height="64" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
						<use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Pointer_32x32"></use>
					</svg>
				</div>`;

		var overlay = $(template);


		function handleTableOverlay(table) {

			if ($("html").hasClass("touch") || window.USER_IS_TOUCHING) {
				var parent = table.parent();

				if (table.width() > parent.width()) {

					parent.append(overlay.clone());

					parent.on("click touchstart", () => {
							parent.find(".show-overlay").remove();
					});

				}
			}
		}

		responsiveTables.each(function () {

			var table = $(this);

			if (table.parent().hasClass("resp-table")) {
				return;//Never wrap table more than once 
			}

			table.wrap("<div class='resp-table'></div>");

			handleTableOverlay(table);
		});

	}

	init();

})(jQuery);